import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import ar from './locales/ar/translation.json';
import de from './locales/de/translation.json';
import pt from './locales/pt/translation.json';
import it from './locales/it/translation.json';
import ru from './locales/ru/translation.json';
import zh from './locales/zh/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      ar: { translation: ar },
      de: { translation: de },
      pt: { translation: pt },
      it: { translation: it },
      ru: { translation: ru },
      zh: { translation: zh },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr','en','es','ar','de','pt','it','ru','zh'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'kadmiai_lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;

// RTL languages
export const RTL_LANGS = ['ar'];

// Langues complètes (100% traduites)
export const SUPPORTED_LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

// Langues en beta (traductions partielles) - désactivées pour l'instant
// Réactiver quand les traductions seront complètes
export const BETA_LANGUAGES = [
  { code: 'ar', label: 'العربية', flag: '🇸🇦' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
];
